import { derived, readable, type Readable } from 'svelte/store';

import { TeoCore } from '@/teoCore/TeoCore';
import type { TeoText } from '@/teoCore/text/TeoText';
import type { TeoTextStore } from '@/teoCore/text/TeoText.store';
import type { TeoView } from '@/teoCore/text/TextUi';

export function useActiveTeoText(): Readable<TeoText> {
  return readable(TeoCore.instance.activeText, (set) => {
    return TeoCore.instance.events.addEventListener('activeTextChanged', () => {
      set(TeoCore.instance.activeText);
    });
  });
}

export function useActiveTextStoreState(): Readable<TeoTextStore['state']> {
  return derived(
    useActiveTeoText(),
    ($text, set) => $text.store.subscribe(set),
    TeoCore.instance.activeText.store.state,
  );
}

export function useHasViewType(views: TeoView | TeoView[]) {
  const storeState = useActiveTextStoreState();
  return derived(storeState, (store) => {
    if (!store.view) return false;
    return Array.isArray(views) ? views.includes(store.view) : views === store.view;
  });
}
